export const SignStatusTypes = {
  onSign: "На подписание",
  signed: "Подписан",
  rejected: "отклонен",
  comment: "Оставить замечание",
} as const;

export type SignStatusEnum = (typeof SignStatusTypes)[keyof typeof SignStatusTypes];
